import DropdownIcon from "icon/dropdown";
import { useState } from "react";
import NavItem from "./nav-item";

function NavDropdown({ label, path, icon, children, onNavigate }) {
  const [toggleNav, setToggleNav] = useState(false);

  const sa_bg_color = "white";
  const sa_text_color = "#0a4d85";
  const s_text_color = "white";

  return (
    <li>
      <button
        type="button"
        className="flex items-center w-full p-2 text-base text-white transition duration-75 rounded-lg group"
        onClick={() => setToggleNav(!toggleNav)}
        onMouseEnter={(e) =>
          e.currentTarget.setAttribute(
            "style",
            `background-color: ${sa_bg_color}; color: ${sa_text_color}`
          )
        }
        onMouseLeave={(e) =>
          e.currentTarget.setAttribute(
            "style",
            `background-color: transparent; color: ${s_text_color}`
          )
        }
      >
        {icon}
        <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">
          {label}
        </span>
        <DropdownIcon
          className={`${
            toggleNav ? "rotate-180" : ""
          } transition-all duration-300`}
        />
      </button>

      {toggleNav && (
        <ul id="dropdown-example" className="py-2 space-y-2 mx-3">
          {children.map((item) => (
            <NavItem
              key={item.key}
              {...item}
              onClick={() => {
                if (onNavigate) onNavigate(item.path); // ✅ Close sidebar + navigate
              }}
            />
          ))}
        </ul>
      )}
    </li>
  );
}

export default NavDropdown;
